module.exports = __webpack_public_path__ + "img/nga.992459a3.svg";